// extracted by mini-css-extract-plugin
module.exports = {"value":"DescriptionListItem_value__1mQJj"};